import {CATEGORY, getBoardIdListingId, getDatesLabel, generic} from '../edap';
import edapUtils, {GENERIC_EVENT, trigger} from '../../utils/edap';

export const named = {
    TRIPBOARDS_VOTE : 'tripboards.vote',
    TRIPBOARDS_CARD_COMMENT_ADD: 'tripboards.card.comment.add',
    TRIPBOARDS_CARD_COMMENT_DELETE: 'tripbards.card.comment.delete',
    TRIPBOARDS_CARD_COMMENT_EDIT: 'tripboards.card.comment.edit'
};

const namedCommentEvent = (event, boardId, role, endDate, startDate, listingId) => {
    const accesstype = edapUtils.getEdapRoleFromRole(role);
    let options = {
        boardid: boardId,
        accesstype,
        listingid: listingId
    };

    if (endDate && startDate) {
        options.eventenddate = endDate;
        options.eventstartdate = startDate;
    }

    trigger(event, options);
};

export const addComment = (boardId, endDate, listingId, startDate, role) => {
    namedCommentEvent(named.TRIPBOARDS_CARD_COMMENT_ADD, boardId, role, endDate, startDate, listingId);

    trigger(GENERIC_EVENT, {
        eventaction: generic.TRIP_BOARDS_COMMENT_ADD,
        eventcategory: CATEGORY,
        eventlabel: `${getBoardIdListingId(boardId, listingId)};${getDatesLabel(startDate, endDate)}`
    });
};

export const viewComments = (boardId, endDate, listingId, startDate) => {
    trigger(GENERIC_EVENT, {
        eventaction: generic.TRIP_BOARDS_COMMENT_CLICK,
        eventcategory: CATEGORY,
        eventlabel: `${getBoardIdListingId(boardId, listingId)};${getDatesLabel(startDate, endDate)}`
    });
};

export default {
    addComment,
    viewComments
};



// WEBPACK FOOTER //
// ./src/universal/tripboard/comments/edap.js